export default __webpack_public_path__ + "static/media/arrow-right-2.abf928ab.svg";